
// ========================================
// FIREBASE CONFIGURATION
// ========================================
const FIREBASE_CONFIG = {
    apiKey: "AIzaSyDtLbnJHw15PfGC-WxG-cSQjn8gJqqxhWs",
    projectId: "marketing-system-by-bar",
    databaseURL: "https://marketing-system-by-bar-default-rtdb.firebaseio.com"
};

// ========================================
// MAIN TRACKING CLASS
// ========================================
class SessionTracker {
    constructor(sessionId) {
        this.sessionId = sessionId;
        this.startTime = Date.now();
        this.clicks = 0;
        this.isVisible = false;
        this.heartbeatInterval = null;
        
        this.init();
    }
    
    init() {
        console.log(`🎯 Session Tracking initialized for: ${this.sessionId}`);
        
        // Send initial view event
        this.sendEvent('view');
        
        // Set up click tracking
        this.setupClickTracking();
        
        // Set up visibility tracking
        this.setupVisibilityTracking();
        
        // Set up heartbeat (every 30 seconds)
        this.setupHeartbeat();
        
        // Track session end
        this.setupSessionEnd();
    }
    
    setupClickTracking() {
        const element = document.querySelector(`[data-session-id="${this.sessionId}"]`);
        if (!element) return;
        
        element.addEventListener('click', (e) => {
            this.clicks++;
            this.sendEvent('click', {
                element: e.target.tagName,
                text: e.target.textContent.substring(0, 50)
            });
        });
    }
    
    setupVisibilityTracking() {
        const element = document.querySelector(`[data-session-id="${this.sessionId}"]`);
        if (!element) return;
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.isVisible) {
                    this.isVisible = true;
                    this.sendEvent('visible');
                } else if (!entry.isIntersecting && this.isVisible) {
                    this.isVisible = false;
                    this.sendEvent('hidden');
                }
            });
        }, { threshold: 0.5 });
        
        observer.observe(element);
    }
    
    setupHeartbeat() {
        this.heartbeatInterval = setInterval(() => {
            if (this.isVisible) {
                const duration = Math.floor((Date.now() - this.startTime) / 1000);
                this.sendEvent('heartbeat', {
                    duration,
                    clicks: this.clicks
                });
            }
        }, 30000); // Every 30 seconds
    }
    
    setupSessionEnd() {
        window.addEventListener('beforeunload', () => {
            const duration = Math.floor((Date.now() - this.startTime) / 1000);
            this.sendEvent('session_end', {
                duration,
                clicks: this.clicks
            }, true); // Synchronous
        });
    }
    
    async sendEvent(eventType, data = {}, sync = false) {
        const event = {
            sessionId: this.sessionId,
            eventType,
            timestamp: new Date().toISOString(),
            url: window.location.href,
            ...data
        };
        
        const url = `${FIREBASE_CONFIG.databaseURL}/session_events.json`;
        
        try {
            if (sync) {
                // Synchronous request for beforeunload
                const blob = new Blob([JSON.stringify(event)], { type: 'application/json' });
                navigator.sendBeacon(url, blob);
            } else {
                // Asynchronous request
                await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(event)
                });
            }
            
            console.log(`📊 Event sent: ${eventType}`, event);
        } catch (error) {
            console.error(`❌ Failed to send event: ${eventType}`, error);
        }
    }
}

// ========================================
// AUTO-DETECT AND TRACK SESSIONS
// ========================================
document.addEventListener('DOMContentLoaded', () => {
    // Find all elements with data-session-id
    const trackedElements = document.querySelectorAll('[data-session-id]');
    
    console.log(`🔍 Found ${trackedElements.length} tracked section(s)`);
    
    // Initialize tracker for each element
    trackedElements.forEach(element => {
        const sessionId = element.getAttribute('data-session-id');
        if (sessionId && sessionId.trim()) {
            new SessionTracker(sessionId);
        }
    });
    
    // Log if no sections found
    if (trackedElements.length === 0) {
        console.warn('⚠️ No sections with data-session-id found. Add data-session-id="{{ section.id }}" to track sections.');
    }
});
